export var listItemContentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      flexGrow: 1,
      fontSize: v.contentFontSize,
      lineHeight: v.contentLineHeight
    }, p.truncate && {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }, (!p.hasHeader || p.hasContentMedia) && {
      marginRight: v.gap
    });
  }
};
//# sourceMappingURL=listItemContentStyles.js.map
